import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'formatUid'
})
export class FormatUidPipe implements PipeTransform {

  transform(uid: string): string {
    if (!uid) {
      return '';
    }

    // Falls UID bereits formatiert aus der DB reinkommt
    uid = uid.replace(/[^a-zA-Z0-9]/g, "");

    const prefix = uid.substr(0, 3);
    const part1 = uid.substr(3, 3);
    const part2 = uid.substr(6, 3);
    const part3 = uid.substr(9, 3);
    return prefix + '-' + part1 + '.' + part2 + '.' + part3;
  }

}
